<button mat-raised-button color="primary" (click)="openAddConfigDialog()">Add config</button>
